module.exports = __webpack_public_path__ + "img/5.116f7467.jpeg";